import React, { useState, useEffect } from 'react';

const TimePickerModal = ({ 
  isOpen, 
  onClose, 
  initialTime = "08:00:00",
  title = "Seleccionar hora",
  onSave 
}) => {
  const [hours, setHours] = useState(8);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const HOURS_RANGE = {
    start: 8,
    end: 18
  };
  
  const availableHours = Array.from(
    { length: HOURS_RANGE.end - HOURS_RANGE.start + 1 }, 
    (_, i) => HOURS_RANGE.start + i
  );
  
  useEffect(() => {
    if (initialTime) {
      const [h, m, s] = initialTime.split(':').map(Number);
      const validHour = Math.max(HOURS_RANGE.start, Math.min(HOURS_RANGE.end, h || HOURS_RANGE.start));
      setHours(validHour);
      setMinutes(m || 0);
      setSeconds(s || 0);
    }
  }, [initialTime]);

  const handleSave = () => {
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    onSave(formattedTime);
  };

  const scrollToSelected = (containerId, selectedValue, type = '') => {
    const container = document.getElementById(containerId);
    if (container) {
      let selectedIndex;
      
      if (type === 'hours') {
        selectedIndex = availableHours.indexOf(selectedValue);
      } else {
        selectedIndex = selectedValue;
      }
      
      const selectedElement = container.children[selectedIndex + 1];
      
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  
  useEffect(() => {
    if (isOpen) {
    setTimeout(() => {
      scrollToSelected('hours-container', hours, 'hours');
      scrollToSelected('minutes-container', minutes, 'minutes');
      scrollToSelected('seconds-container', seconds, 'seconds');
    }, 100);
    }
  }, [isOpen, hours, minutes, seconds]);

  const handleTimeChange = (type, value) => {
    switch (type) {
      case 'hours':
        setHours(value);
        break;
      case 'minutes':
        setMinutes(value);
        break;
      case 'seconds':
        setSeconds(value);
        break;
      default:
        break;
    }

    setTimeout(() => {
      scrollToSelected(`${type}-container`, value, type);
    }, 50);
  };
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-[90%] sm:w-[433px] relative pt-12 p-6 bg-white rounded-[29px] ">
        <button 
          className="absolute p-2 text-black top-4 right-4"
          onClick={onClose} 
        >
          <svg width="12" height="12" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L17 17M1 17L17 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        <h3 className="text-[15px] font-itcdemi text-blue">{title}</h3>
        
        <div className='flex items-center justify-center w-full pt-4'>
          <div className='grid text-sm font-roboto-regular text-[#6B7280] items-center w-[183.53px]  justify-center grid-cols-2 text-center '>
            <p>Horas</p>
            <p>Minutos</p>
          </div>
        </div>
        <div className="relative flex items-center justify-center p-4 ">
          {/* Líneas indicadoras */}
          <div className="flex ">
            {/* Horas */}
            <div className="flex flex-col h-[210px] items-center">
              <div 
                id="hours-container"
                className="overflow-y-auto bg-white rounded-lg scrollbar-hide"
              >
                <div className="px-4 h-[70px] py-3 text-center text-4xl sm:text-[48px]  flex items-center justify-center opacity-0">
                  00
                </div>
                {availableHours.map((hour) => (
                  <div 
                    key={hour}
                    className={`px-4 py-3 h-[70px] text-center cursor-pointer text-4xl sm:text-[48px] transition-all flex items-center justify-center ${
                      hours === hour ? ' text-[#6B7280] font-robotoregular' : 'text-[#D9D9D9]'
                    }`}
                    onClick={() => handleTimeChange('hours', hour)}
                  >
                    {hour.toString().padStart(2, '0')}
                  </div>
                ))}
                <div className="px-4 py-3 h-[70px] text-center text-4xl sm:text-[48px]  flex items-center justify-center opacity-0">
                  00
                </div>
              </div>
            </div>
            
            {/* Separador */}
            <div className="flex flex-col  h-[210px] items-center justify-center">
              <div className="flex items-center justify-center ">
                <span className="text-4xl sm:text-[48px]  font-robotoregular text-[#6B7280]">:</span>
              </div>
            </div>
            
            {/* Minutos */}
            <div className="flex h-[210px] flex-col items-center">
              <div 
                id="minutes-container"
                className="overflow-y-auto bg-white rounded-lg scrollbar-hide"
              >
                <div className="px-4 py-3 h-[70px] text-center text-4xl sm:text-[48px]  flex items-center justify-center opacity-0">
                  00
                </div>
                {Array.from({ length: 60 }, (_, i) => (
                  <div 
                    key={i}
                    className={`px-4 py-3 h-[70px] text-center cursor-pointer text-4xl sm:text-[48px]  transition-all flex items-center justify-center ${
                      minutes === i ? ' text-[#6B7280] font-robotoregular' : 'text-[#D9D9D9]'
                    }`}
                    onClick={() => handleTimeChange('minutes', i)}
                  >
                    {i.toString().padStart(2, '0')}
                  </div>
                ))}
                <div className="px-4 py-3 h-[70px] text-center text-4xl sm:text-[48px]  flex items-center justify-center opacity-0">
                  00
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='flex items-center justify-center w-full'>
          <button
            onClick={handleSave}
            className="underline font-itcbook text-blue"
          >
            Aceptar
          </button>
        </div>
      </div>
      
      <style>
      {`
      .scrollbar-hide {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
      }

      .scrollbar-hide::-webkit-scrollbar {
        display: none;  /* Chrome, Safari and Opera */
      }
      `}
      </style>
    </div> 
  );
};

export default TimePickerModal;